/**
 * Scroll to a previously viewed card after navigating back from a detail page.
 * Works with CBackButton which stores the card element ID in sessionStorage.
 */
export function scrollToCardFromSession() {
    if (!import.meta.client) return

    const scrollTarget = sessionStorage.getItem('scrollToCard')
    if (!scrollTarget) return

    sessionStorage.removeItem('scrollToCard')
    nextTick(() => {
        // Small delay to let images/layout settle
        setTimeout(() => {
            const el = document.getElementById(scrollTarget)
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }, 150)
    })
}
